import { provideAppDestroy, type AppDestroy } from '@bcf-vanilla-ts-v1-shared/di/app-destroy';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import {
  provideModalStandaloneResolverSignalService,
  type ModalStandaloneResolverSignalService
} from './modal-standalone-resolver-signal.service';

export class ModalConfirmService {
  public show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public confirm$: Subject<boolean> = new Subject<boolean>();
  public message$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public title$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
  public yesButtonTitle$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
  public noButtonTitle$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  constructor(
    private _modalStandaloneResolverSignal: ModalStandaloneResolverSignalService,
    private _appDestroy: AppDestroy
  ) {
    this._init();
  }

  private _init(): void {
    this.show$
      .pipe(takeUntil(this._appDestroy.destroy$))
      .subscribe(this._modalStandaloneResolverSignal.resolve('confirm'));
  }
}

export function provideModalConfirmService(): ModalConfirmService {
  return provideSingleton(
    ModalConfirmService,
    () => new ModalConfirmService(provideModalStandaloneResolverSignalService(), provideAppDestroy())
  );
}
